var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9268 6.90052C55.6123 9.58499 55.6123 13.942 52.9268 16.6276L47.3301 22.2243L33.3652 8.26263L38.9619 2.66488C41.6475 -0.0204541 46.0088 -0.0204541 48.6943 2.66488L52.9268 6.90052ZM25.792 12.9323C24.8789 11.9225 23.2461 11.9225 22.2363 12.9323L11.1826 23.8034C10.2695 24.8991 8.63673 24.8991 7.63019 23.8034C6.62364 22.8903 6.62364 21.2575 7.63019 20.2477L18.5947 9.28744C21.6133 6.26673 26.5117 6.26673 29.5303 9.28744L44.8916 24.652L24.6533 44.901C19.4971 50.0573 12.9229 53.57 5.76857 54.9987L3.08409 55.5358C2.23868 55.7076 1.36427 55.4391 0.755186 54.7409C0.145674 54.2252 -0.118906 53.3551 0.0500687 52.5065L0.587071 49.8209C2.01739 42.6666 5.53439 36.0924 10.6928 30.9362L27.2959 14.3395L25.792 12.9323Z",
    fill: "url(#paint0_linear_166_1939)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_166_1939",
    x1: -14.5727,
    y1: -20.4781,
    x2: 53.8109,
    y2: -3.32871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78B88"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.0b55baede2446517e6b3d767471ea9dd.svg";
export { ForwardRef as ReactComponent };